import { useState } from "react";
import { useTranslation } from "react-i18next";
import ProjectActivityPanel from "components/project/project-activity-panel/project-activity-panel";

type Props = {
  companyId: string;
  projectId: string;
  cardName?: string;
  defaultAssigneeId?: string | null;
  onSaved?: () => void;
};

export default function ProjectActivityCompose({
  companyId,
  projectId,
  cardName,
  defaultAssigneeId,
  onSaved,
}: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full rounded-md border border-dashed border-[var(--p-color-border)] px-4 py-3 text-left text-sm text-[var(--p-color-text-secondary)] hover:border-[var(--p-color-border-focus)] hover:bg-[var(--p-color-bg-surface-secondary)]"
      >
        {t("project_activity_compose_hint", {
          defaultValue: "Click here to add an activity…",
        })}
      </button>
    );
  }

  return (
    <div>
      <ProjectActivityPanel
        companyId={companyId}
        projectId={projectId}
        cardName={cardName}
        defaultAssigneeId={defaultAssigneeId}
        composerOnly
        onSaved={() => {
          onSaved?.();
        }}
      />
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="mt-2 text-xs font-medium text-[var(--p-color-text-link)]"
      >
        {t("collapse", { defaultValue: "Collapse" })}
      </button>
    </div>
  );
}
